import styled from "styled-components"

export const Button=styled.div`
    cursor:pointer;
    display:block;
 height:23px;
`
